import { useQueries } from "@tanstack/react-query";
import { styled } from "@monolith-forensics/monolith-ui";

import Loader from "@/components/Loader";
import { EvidenceCustomFields, InquiryCustomFields } from "./components";
import { CUSTOM_FIELD_CATEGORIES } from "../../CustomFieldSettings/utils/customFieldConstants";
import CustomFieldsApi from "@/api/custom-fields";

const StyledContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  flex: 1 1 auto;
  overflow-y: auto;
`;

export const CustomFieldOptions = () => {
  const [
    { isLoading: isInquiryDataLoading, data: customInquiryFields },
    { isLoading: isEvidenceDataLoading, data: customEvidenceFields },
  ] = useQueries({
    queries: [
      {
        queryKey: [
          "customInquiryFields",
          { category: CUSTOM_FIELD_CATEGORIES.INQUIRY },
        ],
        queryFn: () =>
          CustomFieldsApi.getCustomFields({
            category: CUSTOM_FIELD_CATEGORIES.INQUIRY,
          }),
      },
      {
        queryKey: [
          "customEvidenceFields",
          { category: CUSTOM_FIELD_CATEGORIES.EVIDENCE },
        ],
        queryFn: () =>
          CustomFieldsApi.getCustomFields({
            category: CUSTOM_FIELD_CATEGORIES.EVIDENCE,
          }),
      },
    ],
  });

  if (isInquiryDataLoading || isEvidenceDataLoading) return <Loader />;

  return (
    <StyledContainer>
      <InquiryCustomFields customFields={customInquiryFields} />
      <EvidenceCustomFields customFields={customEvidenceFields} />
    </StyledContainer>
  );
};
